import { useState } from "react";
import { DMCIntroOverlay } from "~/ScanDMC/components/DMCIntroOverlay/DMCIntroOverlay";
import { DMCScanPage } from "~/ScanDMC/pages/DMCScanPage/DMCScanPage";
import ErrorOverlay from "./components/ErrorOverlay/ErrorOverlay";
import { type OriginCheckResult, ScanResultType } from "./models/ScanDMC";
import { getCookie, setCookie } from "~/utils/cookie";
import ContactFormOverlay from "~/ScanDMC/components/ContactFormOverlay/ContactFormOverlay";
import { redirectToProduct } from "~/ScanDMC/scanDmcUtils";

function isDontShowIntoCookieSet() {
  return getCookie("scanDMCIntroRead")?.value === "true";
}

const ERROR_FORM_RESULTS: ScanResultType[] = [ScanResultType.NoCodeDetected, ScanResultType.UnknownError];

const CONTACT_FORM_RESULTS: ScanResultType[] = [ScanResultType.Counterfeit, ScanResultType.UnknownCode];

export const ScanDMC = () => {
  const [dontShowIntroFlag, setDontShowIntoFlag] = useState<boolean>(isDontShowIntoCookieSet);
  const [userOpenedIntro, setUserOpenedIntro] = useState(false);
  const [showIntroOverlay, setShowIntroOverlay] = useState<boolean>(() => !isDontShowIntoCookieSet());

  const [result, setResult] = useState<OriginCheckResult>();
  const [forceShowContactForm, setForceShowContactForm] = useState(false);

  const onScanResult = async (result: OriginCheckResult) => {
    if ("productCode" in result && result.productCode) {
      redirectToProduct(result as Required<OriginCheckResult>);
      // Never resolve the promise
      return new Promise<void>(() => {});
    } else {
      setResult(result);
    }
  };

  const openHelp = () => {
    setUserOpenedIntro(true);
    setDontShowIntoFlag(true);
    setShowIntroOverlay(true);
  };

  const closeHelp = (dontShowIntroFlag: boolean) => {
    if (dontShowIntroFlag && !userOpenedIntro) {
      setCookie({
        name: "scanDMCIntroRead",
        value: "true",
      });
      setDontShowIntoFlag(true);
    }

    setShowIntroOverlay(false);
  };

  const closeOverlays = () => {
    setResult(undefined);
    setForceShowContactForm(false);
  };

  let showContactForm = false;
  let showErrorOverlay = false;
  if (result) {
    showContactForm = CONTACT_FORM_RESULTS.includes(result?.type) || forceShowContactForm;
    showErrorOverlay = !showContactForm;
  }

  const showMainPage = !result;
  const initialIntro = !userOpenedIntro && showIntroOverlay;

  return (
    <>
      {showMainPage && !initialIntro && <DMCScanPage onScanResult={onScanResult} onShowHelp={openHelp} />}
      {showIntroOverlay && <DMCIntroOverlay dontShowAgain={dontShowIntroFlag} onReturn={closeHelp} />}
      {showContactForm && (
        <ContactFormOverlay
          showAlert={!forceShowContactForm}
          scanResult={result!.type}
          onClose={closeOverlays}
          dmcCode={result!.dmcCode}
        />
      )}
      {showErrorOverlay && (
        <ErrorOverlay scanResult={result!} onReturn={closeOverlays} onContactUs={() => setForceShowContactForm(true)} />
      )}
    </>
  );
};

export const createScanDMCPage = () => {
  return <ScanDMC />;
};
